import * as Yup from 'yup'
import { TFunction } from 'i18next'
import { CreatePromotionFormState } from '../model/types'

export const createPromotionFormDefault: CreatePromotionFormState = {
  name: '',
  start_date: '',
  end_date: null,
  is_permanent: false,
  thumbnail: null,
  description: '',
  residential_projects: [],
}

export const createPromotionFormSchema = (t: TFunction) => {
  return Yup.object().shape({
    is_permanent: Yup.boolean(),
    name: Yup.string().required(t('common:validation_messages.required')),
    start_date: Yup.date().required(t('common:validation_messages.required')),
    end_date: Yup.date()
      .nullable()
      .when('is_permanent', {
        is: false,
        then: schema =>
          schema.required(t('common:validation_messages.required')).test(
            'end-after-start',
            t('common:validation_messages.date_must_be_after', {
              field: t('promotion:start_date'),
            }),
            function (end) {
              const { start_date } = this.parent
              if (!start_date || !end) return true
              return new Date(end) >= new Date(start_date)
            },
          ),
        otherwise: schema => schema.notRequired().nullable(),
      }),
    thumbnail: Yup.string().nullable(),
    description: Yup.string()
      .min(50, t('common:validation_messages.min', { count: 50 }))
      .required(t('common:validation_messages.required')),
    residential_projects: Yup.array()
      .of(Yup.number().integer())
      .min(1, t('common:validation_messages.required'))
      .required(t('common:validation_messages.required')),
  })
}
